<template>
    <div class="hslp-upsell">
        <b-row
            class="mb-6"
            align-h="center"
        >
            <b-col cols="10">
                <div class="h2 text-center mb-2">
                    Get Home Sale Legal Protection™ - after the sale, it will be too late
                </div>

                <div class="font-size-4 text-center mb-4">
                    Provides you peace of mind from home sale legal claims for pennies of the sale.
                </div>
            </b-col>
        </b-row>

        <div class="mb-5">
            <hslp-form-pre-eula
                ref="HslpFormPreEula"
                :is-public="isPublic"
                is-upsell
                :upsell-payment-visible="upsellPaymentVisible"
                :order-app-resource="orderAppResource"
                :seller-app-resource="sellerAppResource"
                @change-payment-method="handleChangePaymentMethod"
                @click-no-protection="clickNoProtection"
            />
        </div>

        <div v-if="selectedPaymentMethod === 'pay-now' && upsellPaymentVisible">
            <b-row
                class="mb-3"
                align-h="center"
            >
                <b-col cols="4">
                    <b-button
                        variant="primary"
                        size="lg"
                        block
                        @click="addProtection"
                    >
                        <b-spinner
                            class="mr-1"
                            small
                            v-if="saving"
                        />

                        Pay now
                    </b-button>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center">
                <b-button
                    class="text-dark"
                    variant="tertiary"
                    size="lg"
                    @click="upsellPaymentVisible = false"
                >
                    Cancel
                </b-button>
            </div>
        </div>

        <div v-else-if="selectedPaymentMethod === 'pay-at-close' && upsellPaymentVisible">
            <b-row
                class="mb-3"
                align-h="center"
            >
                <b-col
                    cols="12"
                    md="4"
                >
                    <b-button
                        variant="primary"
                        size="lg"
                        block
                        @click="protectYourSale"
                    >
                        <b-spinner
                            class="mr-1"
                            small
                            v-if="saving"
                        />

                        Protect your sale
                    </b-button>
                </b-col>
            </b-row>

            <div class="d-flex justify-content-center">
                <b-button
                    class="text-dark"
                    variant="tertiary"
                    size="lg"
                    @click="upsellPaymentVisible = false"
                >
                    Cancel
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import FormErrorsMixin from '@sellers-shield-home-protection/ss-ui-kit/src/components/FormErrors/FormErrorsMixin';
import HslpFormPreEula from '@components/other/HslpForm/HslpFormPreEula';
import {pageId} from "@helpers/fromPage";
import {isAgent} from "@helpers/user";

export default {
    name: 'HslpUpsell',
    mixins: [
        FormErrorsMixin,
    ],
    components: {
        HslpFormPreEula,
    },
    data: () => ({
        saving: false,
        upsellPaymentVisible: false,
        selectedPaymentMethod: '',
    }),
    props: {
        orderAppResource: {
            type: Object,
            required: true,
        },
        sellerAppResource: {
            type: Object,
        },
        isPublic: {
            type: Boolean,
        },
    },
    methods: {
        async handleChangePaymentMethod(selectedPaymentMethod) {
            this.selectedPaymentMethod = selectedPaymentMethod;
            this.upsellPaymentVisible = true;
        },
        async protectYourSale() {
            if (this.selectedPaymentMethod === 'pay-now') {
                this.upsellPaymentVisible = true;
            } else {
                await this.addProtection();
            }
        },
        async addProtection() {
            await this.catchAppResourceErrors(async () => {
                let paymentResponse = await this.$refs.HslpFormPreEula.addProtection(this.currentPageId);
                if(paymentResponse) {
                    if (this.isPublic) {
                        this.$emit('addProtection');
                    } else {
                        await this.$router.push({name: 'dashboard'});
                    }
                }
            }, 'saving');
        },
        async clickNoProtection() {
            this.isPublic ?
                this.$emit('noProtection') :
                await this.$router.push({name: 'dashboard'});
        },
    },
    computed: {
        currentPageId() {
            return pageId(this.$route.name, isAgent);
        }
    }
}
</script>
